// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "./assets/common.css"
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import store from './store/index';
import "./assets/style.css";
// import "./assets/style-mob.css";
iView.Message.config({
    top: 150,
    duration: 3
});
Vue.use(iView);

Vue.config.productionTip = false

iView.Message.config({
    top: 150,
    duration: 3
});

router.beforeEach((to, from, next) => {
    store.dispatch('setRouterName', to.name);
    next();
});

// 跳转后返回顶部
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js